/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';
import React from 'react';
import moment from 'moment';
import {
  injectIntl,
} from 'react-intl';
import {
  Grid,
  Row,
  Col,
  Panel,
  Table,
} from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import Toolbar from 'loracoms/Toolbar';
import { callAPI } from 'lorautils/api';
import LineChart from 'loracoms/LineChart';
import BarChart from 'loracoms/BarChart';
import LoadingTable from 'loracoms/LoadingTable';
import InlineSelect from 'loracoms/InlineSelect';
import SortBtn from 'loracoms/SortBtn';
import loadingImg from 'loraimages/chart_loading.gif';
import styles from './styles.scss';

const kPending = 'pending';
const propTypes = {
  intl: React.PropTypes.any.isRequired,
};

class CapacityView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadData: [],
      freqData: [],
      tableData: [],
      redundancyData: [],
      networkStatus: kPending,
      freqStatus: kPending,
      listStatus: kPending,
      queryHours: 24,
      sortKey: 'deveui',
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.capacityview');
  }

  componentDidMount() {
    this.mounted = true;
    this.loadNetworkAnalysisList();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  loadNetworkAnalysisList() {
    this.setState({
      networkStatus: kPending,
      listStatus: kPending,
      freqStatus: kPending,
    });

    callAPI({
      endpoint: '/na/network_load_summary',
      query: {
        hours: this.state.queryHours,
      },
    }).then((data) => {
      if (this.mounted) {
        this.setState({
          networkStatus: 'success',
          loadData: data || [],
        });
      }
    }).catch(() => {
      this.setState({
        networkStatus: 'failure',
      });
    });

    callAPI({
      endpoint: '/na/frequency_load_summary',
      query: {
        hours: this.state.queryHours,
      },
    }).then((data) => {
      if (this.mounted) {
        this.setState({
          freqStatus: 'success',
          freqData: data || [],
        });
      }
    }).catch(() => {
      this.setState({
        freqStatus: 'failure',
      });
    });

    const a = callAPI({
      endpoint: '/na/device_packet_redundancy_summary',
      query: {
        hours: this.state.queryHours,
      },
    });
    const b = callAPI({
      endpoint: '/na/device_interval_summary',
      query: {
        hours: this.state.queryHours,
      },
    });
    Promise.all([a, b]).then((res) => {
      this.setState({
        redundancyData: res[0] || [],
        tableData: res[1] || [],
        listStatus: 'success',
      });
    }).catch(() => {
      this.setState({ listStatus: 'failure' });
    });
  }

  handleSort(sort) {
    const tableData = this.state.tableData || [];
    let sortOrder = true;
    let sortKey = '';
    if (sort.startsWith('-')) {
      sortOrder = true;
      sortKey = sort.substr(1);
    } else {
      sortOrder = false;
      sortKey = sort;
    }
    if (sortKey.endsWith('percentile')) {
      tableData.sort((a, b) => {
        if (sortOrder) {
          return a[sortKey][1] >= b[sortKey][1];
        }
        return a[sortKey][1] <= b[sortKey][1];
      });
    } else {
      tableData.sort((a, b) => {
        if (sortOrder) {
          return a[sortKey] >= b[sortKey];
        }
        return a[sortKey] <= b[sortKey];
      });
    }

    this.setState({
      tableData,
      sortKey,
    });
  }

  render() {
    const {
      sortKey = null,
      networkStatus,
      freqStatus,
      listStatus,
      tableData = [],
      loadData = [],
      freqData = [],
      redundancyData = [],
    } = this.state;
    const redundancyDict = {};
    for (let i = 0; i < redundancyData.length; i += 1) {
      const row = redundancyData[i];
      redundancyDict[row.deveui] = row.rate;
    }
    const loadDataCategory = [];
    const GDataValues = [];
    const SDataValues = [];
    const LDataValues = [];
    const tableDataWithRedudancy = [];
    for (let i = 0; i < loadData.length; i += 1) {
      loadDataCategory.push(moment(loadData[i].hours).format('MM/DD HH:00'));
      SDataValues.push(loadData[i].S.toFixed(3));
      LDataValues.push((loadData[i].L.toFixed(3) * 100).toFixed(3));
      GDataValues.push(loadData[i].G.toFixed(3));
    }
    const freqDataCategory = [];
    const freqDataValues = [];
    for (let i = 0; i < freqData.length; i += 1) {
      freqDataCategory.push(freqData[i].frequency);
      freqDataValues.push(freqData[i].load.toFixed(3));
    }
    for (let i = 0; i < tableData.length; i += 1) {
      const row = tableData[i];
      row.rate = (redundancyDict[row.eui] * 100).toFixed(1);
      tableDataWithRedudancy.push(row);
    }
    const thead = (
      <thead>
        <tr>
          <th>
            {this.intlMsg.msg('thead.name')}
            <SortBtn
              sortName="name"
              highLight={sortKey === 'name'}
              handleSort={s => this.handleSort(s)}
            />
          </th>
          <th>
            {this.intlMsg.msg('thead.deveui')}
            <SortBtn
              sortName="eui"
              highLight={sortKey === 'eui'}
              handleSort={s => this.handleSort(s)}
            />
          </th>
          <th>
            {this.intlMsg.msg('thead.interval_median')}
            <SortBtn
              sortName="interval_percentile"
              highLight={sortKey === 'interval_percentile'}
              handleSort={s => this.handleSort(s)}
            />
          </th>
          <th>
            {this.intlMsg.msg('thead.interval_percentile')}
          </th>
          <th>
            {this.intlMsg.msg('thead.toa_median')}
            <SortBtn
              sortName="toa_percentile"
              highLight={sortKey === 'toa_percentile'}
              handleSort={s => this.handleSort(s)}
            />
          </th>
          <th>
            {this.intlMsg.msg('thead.toa_percentile')}
          </th>
          <th>
            {this.intlMsg.msg('thead.total_toa')}
            <SortBtn
              sortName="total_toa"
              highLight={sortKey === 'total_toa'}
              handleSort={s => this.handleSort(s)}
            />
          </th>
          <th>
            {this.intlMsg.msg('thead.rate')}
            <SortBtn
              sortName="rate"
              highLight={sortKey === 'rate'}
              handleSort={s => this.handleSort(s)}
            />
          </th>
          <th>
            {this.intlMsg.msg('thead.total')}
            <SortBtn
              sortName="total"
              highLight={sortKey === 'total'}
              handleSort={s => this.handleSort(s)}
            />
          </th>
          <th>
            {this.intlMsg.msg('thead.last_ts')}
            <SortBtn
              sortName="last_ts"
              highLight={sortKey === 'last_ts'}
              handleSort={s => this.handleSort(s)}
            />
          </th>
        </tr>
      </thead>
    );

    const hoursStr = this.intlMsg.msg('hours');
    const rightTools = [{
      type: 'buttons',
      buttons: [(
        <InlineSelect
          options={[{
            label: `1 ${hoursStr}`,
            value: 1,
          }, {
            label: `6 ${hoursStr}`,
            value: 6,
          },
          {
            label: `12 ${hoursStr}`,
            value: 12,
          }, {
            label: `24 ${hoursStr}`,
            value: 24,
          }, {
            label: `72 ${hoursStr}`,
            value: 72,
          }]}
          values={[this.state.queryHours]}
          onChange={(selected) => {
            this.setState({
              queryHours: selected[0],
            }, () => {
              this.loadNetworkAnalysisList();
            });
          }}
        />
      )],
    }];

    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            <Toolbar
              brandTitle={this.intlMsg.msg('title')}
              rightTools={rightTools}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Panel
              className={styles.panel}
              bsStyle="aisz-white"
              header={this.intlMsg.msg('loadBarChartHeader')}
            >
              {networkStatus === kPending &&
                <div className={styles.loading}>
                  <img src={loadingImg} alt="" />
                </div>
              }
              <LineChart
                series={[{
                  name: this.intlMsg.msg('LoadG'),
                  data: GDataValues,
                  yAxisIndex: 0,
                  type: 'line',
                }, {
                  name: this.intlMsg.msg('LoadS'),
                  data: SDataValues,
                  yAxisIndex: 0,
                  type: 'line',
                }, {
                  name: this.intlMsg.msg('Loss'),
                  data: LDataValues,
                  type: 'bar',
                  yAxisIndex: 1,
                }]}
                legend={{
                  data: [this.intlMsg.msg('LoadG'), this.intlMsg.msg('LoadS'), this.intlMsg.msg('Loss')],
                }}
                yAxis={[
                  {
                    type: 'value',
                    name: this.intlMsg.msg('Load'),
                    scale: true,
                  },
                  {
                    type: 'value',
                    name: this.intlMsg.msg('Loss'),
                    scale: true,
                  },
                ]}
                categories={loadDataCategory}
              />
            </Panel>
          </Col>
          <Col md={6}>
            <Panel
              className={styles.panel}
              bsStyle="aisz-white"
              header={this.intlMsg.msg('freqBarChartHeader')}
            >
              {freqStatus === kPending &&
                <div className={styles.loading}>
                  <img src={loadingImg} alt="" />
                </div>
              }
              <BarChart
                series={[{
                  data: freqDataValues,
                  name: this.intlMsg.msg('Load'),
                  yAxisIndex: 0,
                  type: 'bar',
                }]}
                yAxis={[
                  {
                    type: 'value',
                    name: this.intlMsg.msg('Load'),
                    scale: true,
                  },
                ]}
                categories={freqDataCategory}
              />
            </Panel>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Panel
              bsStyle="aisz-white"
              header={this.intlMsg.msg('tableHeader')}
              className={styles.overflowPanel}
            >
              {listStatus === 'success' &&
              <Table className="aisz-table-light" striped hover bordered responsive>
                {thead}
                <tbody>
                  {
                    tableDataWithRedudancy.map((r, idx) => (
                      <tr key={String(idx)}>
                        <td>{r.name}</td>
                        <td>{r.eui}</td>
                        <td>{r.interval_percentile[1].toFixed(0)}</td>
                        <td>{r.interval_percentile[0].toFixed(0)}&nbsp;-&nbsp;
                           {r.interval_percentile[2].toFixed(0)}</td>
                        <td>{r.toa_percentile[1].toFixed(0)}</td>
                        <td>{r.toa_percentile[0].toFixed(0)}&nbsp;-&nbsp;
                              {r.toa_percentile[2].toFixed(0)}</td>
                        <td>{r.total_toa}</td>
                        <td>{r.rate}</td>
                        <td>{r.total}</td>
                        <td>{moment.unix(r.last_ts / 1000).format('YY-MM-DD HH:mm:ss')}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </Table>
              }
              {listStatus === kPending &&
                <LoadingTable className="aisz-table-light" cols={10} rows={1}>
                  {thead}
                </LoadingTable>
              }
            </Panel>
          </Col>
        </Row>
      </Grid>
    );
  }
}

CapacityView.propTypes = propTypes;

export default injectIntl(CapacityView);




// WEBPACK FOOTER //
// ./src/containers/Network/coms/CapacityView/index.jsx